import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { Observable, of } from 'rxjs'
import { AppSignals, CommonService } from '@appShared/services'
import { AppFacade } from '@appShared/services/app.facade'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Injectable({ providedIn: 'root' })
export class MerchandiseReturnsAuthGuardService {
   private _commonService = inject(CommonService)
   private _appSignals = inject(AppSignals)
   private _router = inject(Router)

   canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

      const currentProfile = this._appSignals.currentProfile()

      if (!currentProfile.canViewPendingMerchandiseReturns) {
         this._commonService.pageNotAuthorized()
         this._router.navigate([SITE_DIRECTORY_ROUTES.uri])

         return of(false)
      }

      return of(true)
   }
}
